import { useState } from 'react';
import Navbar from '../components/Navbar';
import loginbg from '../assets/log.jpg';
import { useNavigate, Link } from 'react-router-dom';
import { API_URL } from '../config';
import { toast } from 'react-toastify';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.warn('Please enter email and password');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.msg || 'Login failed');
      }

      localStorage.setItem('token', data.token);
      toast.success('Login successful!');
      
      // Redirect based on role if needed, or just to profile
      if (data.user.role === 'admin') {
          navigate('/admin');
      } else {
          navigate('/profile');
      }
    } catch (err) {
      if (err.message === 'Failed to fetch') {
        toast.error("Cannot connect to server. Is the backend running?");
      } else {
        toast.error(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div style={styles.container}>
        <div style={styles.overlay}></div>
        <div style={styles.loginBox}>
          <h2 style={styles.title}>CitySathi Login</h2>

          <form style={styles.form} onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter email"
              style={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" style={styles.loginButton} disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <p style={styles.footerText}>
            Don't have an account? <Link to="/register" style={styles.link}>Sign up here</Link>
          </p>
        </div>
      </div>
    </>
  );
};

/* ---------- Styles ---------- */
const styles = {
  container: {
    backgroundImage: `url(${loginbg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.5)',
    zIndex: 1,
  },
  loginBox: {
    background: 'rgba(255,255,255,0.15)',
    backdropFilter: 'blur(12px)',
    padding: '30px',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
    width: '90%',
    maxWidth: '400px',
    textAlign: 'center',
    zIndex: 2,
    color: 'white',
  },
  title: {
    fontSize: '24px',
    marginBottom: '25px',
    fontWeight: '600',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  input: {
    padding: '12px',
    marginTop: '8px',
    marginBottom: '16px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '15px',
    width: '100%',
    boxSizing: 'border-box',
    color: '#333'
  },
  loginButton: {
    backgroundColor: '#319795',
    color: 'white',
    padding: '12px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '600',
    marginTop: '10px',
    transition: 'all 0.3s ease',
  },
  resendText: {
    marginTop: '15px',
    fontSize: '14px',
    textAlign: 'center'
  },
  footerText: {
    marginTop: '25px',
    fontSize: '13px',
    opacity: 0.8
  },
  link: {
    color: '#81e6d9',
    textDecoration: 'underline',
    fontWeight: '600',
    cursor: 'pointer'
  },
};

export default LoginPage;
